/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import styled from 'styled-components';
import IconButton from '@mui/material/IconButton';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { RouteComponentProps } from 'react-router';
import Terminal, { TerminalDetails } from '../../../shared/entities/terminal';
import FullTailViewSelectorContainer from './FullTerminalViewTerminalSelectorContainer';
import StyledProps from '../../common/theme/AppThemeInterface';
import MenuItems from '../../common/layout/menu/MenuItems';
import FullTailViewExportButton from '../FullTailViewExport/FullTailViewExportButton';
import FullTailViewFlightPathZoomButton from './FullTailViewFlightPathZoomButton';
import FullTailViewRulerToolButton from './FullTailViewRulerToolButton';
import { RootState } from '../../../store';
import { connect } from 'react-redux';

interface FullTailViewHeaderContentsProps {
  terminals: { [key: number]: Terminal };
  tailDetailsPanelTerminal: TerminalDetails | undefined;
}

export const BackButtonStyledWrapper = styled.span`
  .ftv__header__back--container {
    color: ${({ theme }: StyledProps) => theme.primaryTextColor};
    margin-left: 6px;
    margin-right: 6px;
  }
`;

class FullTailViewHeaderContents extends React.PureComponent<
  FullTailViewHeaderContentsProps & RouteComponentProps & StateProps
> {
  private onBackButtonClick = () => {
    const { history } = this.props;
    history.push(`/${MenuItems.fleet}`);
  };

  render() {
    return (
      <React.Fragment>
        <BackButtonStyledWrapper>
          <IconButton className="ftv__header__back--container" onClick={this.onBackButtonClick}>
            <ArrowBack />
          </IconButton>
        </BackButtonStyledWrapper>
        <FullTailViewSelectorContainer />
        <FullTailViewFlightPathZoomButton />
        <FullTailViewRulerToolButton />
        <FullTailViewExportButton />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: FullTailViewHeaderContentsProps): any => ({
  userData: state.session.tokens?.idToken,
});
type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, null)(FullTailViewHeaderContents);
